import { DownloadIcon, Edit2Icon, StarIcon, MaximizeIcon } from "vue-feather-icons";
import { TrashEventsService } from "@/services/trashEventsApi";
import Modal from "@/components/modal/modal.vue";
import { createNamespacedHelpers } from "vuex";

const { mapGetters: userGetters } = createNamespacedHelpers("user");

export default {

	props: [ "trashEvent", "parentWidth" ],

	components: {
		DownloadIcon,
		Edit2Icon,
		StarIcon,
		MaximizeIcon,
		Modal,
	},

	computed: {
		trashEventImageOptions,
		trashEventImage,
		trashEventFullSizeImage,
		...userGetters([
			"weightUnitMinor",
			"weightFactorMinor"
		]),
	},

	methods: {
		starTrashEvent,
		setLoader,
		setTrashEventNote,
		reportIncorrectlyLabelledTrashEvent,
		trackFullSizeImageClick
	},

	data() {
		return {
			loaders: {
				star: false,
				note: false,
				report: false,
			},
			noteForm: {
				show: false,
				content: "",
			},
			reportIncorrectLabelModal: {
				show: false,
				content: "",
			},
		};
	},

	created() {
		this.noteForm.content = this.trashEvent.note ? this.trashEvent.note.note : "";
	}

};

function trackFullSizeImageClick() {
	this.$ma.trackEvent({
		action: "Trash Event Item Download",
		properties: {
			"Value": this.trashEvent.description.name,
			"Component": this.$route.name
		}
	});
}

function trashEventImageOptions() {
	return {resize: {width: this.parentWidth, }};
}

function setLoader(key, value) {
	this.loaders = {
		...this.loaders,
		[key]: value,
	};
}

async function starTrashEvent(starred) {
	this.setLoader("star", true);

	if (!starred) {
		this.$ma.trackEvent({
			action: "Trash Event Item Star Click",
			properties: {
				"Value": this.trashEvent.description.name,
				"Component": this.$route.name
			}
		});
	}

	await TrashEventsService
		.starTrashEvent(this.trashEvent.trashevent_id, !this.trashEvent.starred);

	this.$emit("updatedTrashEvent", {
		...this.trashEvent,
		starred: !this.trashEvent.starred,
	});

	this.setLoader("star", false);
}

async function setTrashEventNote() {
	this.setLoader("note", true);

	this.$ma.trackEvent({
		action: "Trash Event Item Note Added",
		properties: {
			"Value": this.noteForm.content,
			"Component": this.$route.name
		}
	});

	await TrashEventsService
		.setTrashEventNote(this.trashEvent.trashevent_id, this.noteForm.content);

	this.$emit("updatedTrashEvent", {
		...this.trashEvent,
		note: {
			note: this.noteForm.content,
			timestamp: new Date(),
		}
	});

	this.noteForm.show = false;
	this.setLoader("note", false);
}

async function reportIncorrectlyLabelledTrashEvent() {
	this.setLoader("report", true);

	await TrashEventsService
		.reportIncorrectlyLabelledTrashEvent(this.trashEvent.trashevent_id,
			this.reportIncorrectLabelModal.content);

	this.$emit("updatedTrashEvent", {
		...this.trashEvent,
		incorrect_label_reported: true,
	});

	this.reportIncorrectLabelModal.show = false;
	this.setLoader("report", false);
}

function trashEventImage() {
	return this.$utils.getImageFromImageId(this.trashEvent.image_id, this.trashEventImageOptions);
}

function trashEventFullSizeImage() {
	return this.$utils.getImageFromImageId(this.trashEvent.image_id);
}
